/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-03-04 16:14:24
 * @LastEditors: cooky
 * @LastEditTime: 2021-05-11 14:14:25
 */
export const ERROR_CONFIG_MAP = {
  1003: 'enter_verification_code', // 无效的验证码
  1005: 'login_error', // 账号或密码错误
  1006: 'roles_id_err', // 角色不存在
  1007: 'role_ready_binded', // 角色已经被绑定
  1008: 'verify_code_send_err', // 验证码发送失败
  1011: 'request_too_frequent', // 请求过于频繁
  1012: 'login_over_time', // 未登录或登录已过期
  1013: 'unselect_role', // 未选定角色
  1014: 'network_err', // 网络异常
  1015: 'product_absent', // 商品不存在
  1016: 'product_overtime',
  1026: 'duplicate_binding', // 重复绑定
  1021: 'has_not_finished_order', // 重复创建支付订单
  103: 'server_overtime' // 请求超时
}
